import { css } from 'styled-components'

export const mixinInputForm = css`
  border: 1px solid ${props => props.theme.members.colors.silver._70};
  padding: 1rem;
  line-height: 1;
  font-size: .875rem;
  width: 100%;
`

export const mixinSmallBadge = css`
  display: inline-flex;
  align-items: center;
  color: ${props => props.theme.members.colors.orange._50};
  border: 1px solid ${props => props.theme.members.colors.orange._50};
  font-size: .75rem;
  font-weight: 700;
  text-align: center;
  padding: 4px 8px;
  border-radius: 4px;
  height: 1.5rem;
  white-space: nowrap;
  margin-right: 8px;
`
